import usePendo from 'common/hooks/usePendo';

const PendoController = () => {
  usePendo();
  return null;
};

export default PendoController;
